import { Component } from "@angular/core";

@Component({
	selector: "app-private",
	templateUrl: "./private.component.html",
	styleUrl: "./private.component.css",
	standalone: false
})
export class PrivateComponent { }